<template>
  <div class="mb-80">
    <div v-if="!hideTitle" class="h4 extrabold mb-16">{{ dictionary.techTitle }}</div>

    <div class="row gx-5 gy-4">
      <div class="col-md-6">
        <div class="b-tech align-items-center">
          <div>
            <LazyImage :image="{ url: '/imgs/icons/transmission.svg' }" />
          </div>
          <div>
            <span>{{ dictionary.techTransmissionLabel }}</span>
            <span class="h6 extrabold">{{ transmissionLabel }}</span>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="b-tech align-items-center">
          <div>
            <LazyImage :image="{ url: '/imgs/icons/fuel.svg' }" />
          </div>
          <div>
            <span>{{ dictionary.techFuelLabel }}</span>
            <span class="h6 extrabold">{{ item.fuel_type }}</span>
          </div>
        </div>
      </div>
      <div v-if="item.co2" class="col-md-6">
        <div class="b-tech align-items-center">
          <div>
            <LazyImage :image="{ url: '/imgs/icons/emmission.svg' }" />
          </div>
          <div>
            <span>{{ dictionary.techEmmissionsLabel }}</span>
            <span class="h6 extrabold">{{ item.co2 }} gr/Km</span>
          </div>
        </div>
      </div>
      <!-- Κατανάλωση Ηλ. Ενέργειας -->
      <div v-if="item.isElectric" class="col-md-6">
        <div class="b-tech align-items-center">
          <div>
            <LazyImage :image="{ url: '/imgs/icons/consumption.svg' }" />
          </div>
          <div>
            <span>{{ dictionary.techElectricConsumptionLabel }}</span>
            <span class="h6 extrabold">
              {{ item.electricConsumption }} kWh/100km
            </span>
          </div>
        </div>
      </div>
      <!-- Κατανάλωση καυσίμου -->
      <div v-else class="col-md-6">
        <div class="b-tech align-items-center">
          <div>
            <LazyImage :image="{ url: '/imgs/icons/consumption.svg' }" />
          </div>
          <div>
            <span>{{ dictionary.techConsumptionLabel }}</span>
            <span class="h6 extrabold">{{ item.consumption }} lt/100Km</span>
          </div>
        </div>
      </div>
      <!-- Μήκος x Πλάτος x Ύψος (mm) -->
      <div class="col-md-6">
        <div class="b-tech align-items-center">
          <div>
            <LazyImage :image="{ url: '/imgs/icons/dimensions@2x.png' }" />
          </div>
          <div>
            <span>{{ dictionary.techDimensionsLabel }}</span>
            <span class="h6 extrabold">
              {{ item.length.toLocaleString(lang) }}mm x
              {{ item.typwidth.toLocaleString(lang) }}mm x
              {{ item.typheight.toLocaleString(lang) }}mm
            </span>
          </div>
        </div>
      </div>
      <!-- Μεταξόνιο -->
      <div class="col-md-6">
        <div class="b-tech align-items-center">
          <div>
            <LazyImage :image="{ url: '/imgs/icons/wheelbase@2x.png' }" />
          </div>
          <div>
            <span>{{ dictionary.techWheelbaseLabel }}</span>
            <span class="h6 extrabold">
              {{ item.typwheelb1.toLocaleString(lang) }}mm
            </span>
          </div>
        </div>
      </div>
      <!-- Πόρτες -->
      <div class="col-md-6">
        <div class="b-tech align-items-center">
          <div>
            <LazyImage :image="{ url: '/imgs/icons/doors@2x.png' }" />
          </div>
          <div>
            <span>{{ dictionary.techDoorsLabel }}</span>
            <span class="h6 extrabold">{{ item.doors }}</span>
          </div>
        </div>
      </div>
      <!-- Θέσεις -->
      <div class="col-md-6">
        <div class="b-tech align-items-center">
          <div>
            <LazyImage :image="{ url: '/imgs/icons/seats@2x.png' }" />
          </div>
          <div>
            <span>{{ dictionary.techSeatsLabel }}</span>
            <span class="h6 extrabold">{{ item.seats }}</span>
          </div>
        </div>
      </div>

      <template v-if="item.isVan">
        <!-- Διαστάσεις χώρου φόρτωσης -->
        <div v-if="showCargoDimensions" class="col-md-6">
          <div class="b-tech align-items-center">
            <div>
              <LazyImage :image="{ url: '/imgs/icons/trunk@2x.png' }" />
            </div>
            <div>
              <span>{{ dictionary.techCargoDimensionsLabel }}</span>
              <span class="h6 extrabold">
                {{ item.TrunkL.toLocaleString(lang) }}mm x
                {{ item.TrunkW.toLocaleString(lang) }}mm x
                {{ item.TrunkH.toLocaleString(lang) }}mm
              </span>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <!-- Χώρος Αποσκευών -->
        <div class="col-md-6">
          <div class="b-tech align-items-center">
            <div>
              <LazyImage :image="{ url: '/imgs/icons/trunk@2x.png' }" />
            </div>
            <div>
              <span>{{ dictionary.techTrunkLabel }}</span>
              <span class="h6 extrabold">{{ item.typtrunkcapmin }}lt</span>
            </div>
          </div>
        </div>
      </template>

      <!-- Αυτονομία σε km -->
      <div v-if="item.isElectric && item.powerRange" class="col-md-6">
        <div class="b-tech align-items-center">
          <div>
            <LazyImage :image="{ url: '/imgs/icons/power-range.png' }" />
          </div>
          <div>
            <span>{{ dictionary.techPowerRangeLabel }}</span>
            <span class="h6 extrabold">
              {{ item.powerRange?.toLocaleString(lang) }} km
            </span>
          </div>
        </div>
      </div>
      <!-- Battery capacity -->
      <div v-if="item.isElectric && item.batCap" class="col-md-6">
        <div class="b-tech align-items-center">
          <div>
            <LazyImage :image="{ url: '/imgs/icons/battery-capacity.png' }" />
          </div>
          <div>
            <span>{{ dictionary.techBatteryCapacityLabel }}</span>
            <span class="h6 extrabold">{{ item.batCap }} Ah</span>
          </div>
        </div>
      </div>
      <!-- Απόβαρο -->
      <div v-if="item.isVan && item.typcurbwgt" class="col-md-6">
        <div class="b-tech align-items-center">
          <div>
            <LazyImage :image="{ url: '/imgs/icons/apovaro.png' }" />
          </div>
          <div>
            <span>{{ dictionary.techTareLabel }}</span>
            <span class="h6 extrabold">
              {{ item.typcurbwgt?.toLocaleString(lang) }} kg
            </span>
          </div>
        </div>
      </div>
      <!--  Ωφέλιμο φορτίο -->
      <div v-if="item.isVan && item.payload" class="col-md-6">
        <div class="b-tech align-items-center">
          <div>
            <LazyImage :image="{ url: '/imgs/icons/ofelimo.png' }" />
          </div>
          <div>
            <span>{{ dictionary.techPayloadLabel }}</span>
            <span class="h6 extrabold">
              {{ item.payload?.toLocaleString(lang) }} kg
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LazyImage from './../common/LazyImage.vue'
import constants from './../../../lib/constants'
import * as lib from '../../../lib/lib'

export default {
  components: { LazyImage },
  props: {
    item: {
      required: true,
      type: Object,
    },
    hideTitle: {
      required: false,
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      lang: 'en',
    }
  },
  computed: {
    showCargoDimensions() {
      return this.item.TrunkL || this.item.TrunkW || this.item.TrunkH
    },

    transmissionLabel() {
      let res
      const transmission = this.item.transmission
      const { manual, auto } = constants.leaseitnow.filters.transmissionsOptions

      switch (transmission) {
        case manual:
          res = this.dictionary.transmissionManual
          break
        case auto:
          res = this.dictionary.transmissionAutomatic
          break
        default:
          res = null
      }
      return res
    },
  },
  mounted() {
    this.lang = lib.getLocaleFromLangAttr()
  },
}
</script>
